
import { useState } from 'react';
import { TextField } from "@mui/material"
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';






export const DateFormScreen = ({ label, size="small", name, onChange, value }) => {



    const handleChange = (newValue) => {
        if (onChange) {
            onChange({ target: { name, value: newValue ? newValue.$d || newValue._d : null } });
        }
    }



    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label}
                value={value}
                onChange={handleChange}
                renderInput={(params) => (
                    <TextField 
                        {...params} 
                        error={false} 
                        fullWidth 
                        size={size} 
                    />
                )}
            />
        </LocalizationProvider>
    )

}

